import { render, staticRenderFns } from "./custom-image.vue?vue&type=template&id=04a1b4ab&scoped=true&"
import script from "./custom-image.vue?vue&type=script&lang=js&"
export * from "./custom-image.vue?vue&type=script&lang=js&"
import style0 from "./custom-image.vue?vue&type=style&index=0&id=04a1b4ab&style=less&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a1b4ab",
  null
  
)

export default component.exports